import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'llamadaConfirmar'
})
export class LlamadaConfirmarPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(value){
      return value + ' Días Antes';
    }else{
      return 'No'
    }
  }

}
